import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter, MapPin, Mail, Phone } from "lucide-react";

const PublicFooter = () => {
    return (
        <footer className="bg-background pt-32 pb-12 border-t border-white/5 relative overflow-hidden" dir="rtl">
            {/* Subtle Grid overlay for footer */}
            <div className="absolute inset-x-0 top-0 h-40 bg-grid opacity-[0.03] pointer-events-none" />

            <div className="container mx-auto px-6 relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-16 mb-24">
                    {/* Brand Info - Spans 4 columns */}
                    <div className="lg:col-span-12 xl:col-span-5">
                        <Link to="/" className="flex items-center gap-3 group mb-8">
                            <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center group-hover:bg-primary transition-colors">
                                <span className="text-background font-black text-xl">T</span>
                            </div>
                            <span className="text-3xl font-black tracking-tighter text-white">
                                TRBD
                            </span>
                        </Link>
                        <p className="text-xl text-muted-foreground font-medium mb-10 max-w-md leading-relaxed">
                            نحن لا نبني برمجيات فقط، بل نؤطر مستقبل أعمالك الرقمي. حلول سورية بمعايير عالمية.
                        </p>
                        <div className="flex gap-4">
                            {[
                                { icon: <Facebook size={18} />, label: 'Facebook' },
                                { icon: <Instagram size={18} />, label: 'Instagram' },
                                { icon: <Linkedin size={18} />, label: 'LinkedIn' },
                                { icon: <Twitter size={18} />, label: 'Twitter' }
                            ].map((social, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center text-white/50 hover:bg-white/10 hover:text-white border border-white/5 transition-all duration-300"
                                    aria-label={social.label}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Navigation - Spans 2 columns */}
                    <div className="lg:col-span-4 xl:col-span-2">
                        <h3 className="text-sm font-black text-white/40 uppercase tracking-widest mb-8">الشركة</h3>
                        <ul className="space-y-4">
                            {[
                                { name: "من نحن", path: "/about" },
                                { name: "خدماتنا", path: "/#services" },
                                { name: "تواصل معنا", path: "/contact" }
                            ].map((link, i) => (
                                <li key={i}>
                                    <Link to={link.path} className="text-lg font-bold text-muted-foreground hover:text-white transition-colors">
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Knowledge - Spans 2 columns */}
                    <div className="lg:col-span-4 xl:col-span-2">
                        <h3 className="text-sm font-black text-white/40 uppercase tracking-widest mb-8">المعرفة</h3>
                        <ul className="space-y-4">
                            {[
                                { name: "المدونة", path: "/blog" },
                                { name: "الأسئلة الشائعة", path: "/faq" },
                                { name: "سياسة الخصوصية", path: "/privacy" },
                                { name: "الشروط والأحكام", path: "/terms" }
                            ].map((item, i) => (
                                <li key={i}>
                                    <Link to={item.path} className="text-lg font-bold text-muted-foreground hover:text-white transition-colors">
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>


                    {/* Contact - Spans 3 columns */}
                    <div className="lg:col-span-4 xl:col-span-3">
                        <h3 className="text-sm font-black text-white/40 uppercase tracking-widest mb-8">تواصل</h3>
                        <div className="space-y-6">
                            <div className="flex items-start gap-4">
                                <MapPin size={20} className="text-primary mt-1 shrink-0" />
                                <span className="text-lg font-bold text-muted-foreground leading-snug">
                                    دمشق، المزة، أوتوستراد المزة الرئيسي
                                </span>
                            </div>
                            <div className="flex items-center gap-4">
                                <Mail size={20} className="text-primary shrink-0" />
                                <a href="mailto:info@trbd.net" className="text-lg font-bold text-muted-foreground hover:text-white transition-colors">info@trbd.net</a>
                            </div>
                            <div className="flex items-center gap-4 group">
                                <Phone size={20} className="text-primary shrink-0" />
                                <a href="https://wa.me/905537323153" target="_blank" rel="noopener noreferrer" className="flex flex-col">
                                    <span className="text-lg font-bold text-muted-foreground font-mono group-hover:text-white transition-colors" dir="ltr">+90 553 732 3153</span>
                                    <span className="text-xs text-white/40 font-bold uppercase tracking-widest">WhatsApp</span>
                                </a>
                            </div>
                            <div className="flex items-center gap-4 group">
                                <Phone size={20} className="text-primary shrink-0" />
                                <a href="https://wa.me/963992367582" target="_blank" rel="noopener noreferrer" className="flex flex-col">
                                    <span className="text-lg font-bold text-muted-foreground font-mono group-hover:text-white transition-colors" dir="ltr">+963 992 367 582</span>
                                    <span className="text-xs text-white/40 font-bold uppercase tracking-widest">Call & WhatsApp</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6">
                    <p className="text-sm font-bold text-white/20 tracking-wide uppercase">
                        © {new Date().getFullYear()} TRBD DIGITAL SOLUTIONS. صنع بحب من دمشق.
                    </p>
                    <div className="flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 text-[10px] font-black uppercase tracking-widest text-white/40">
                        <span className="w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
                        جميع الأنظمة تعمل بكفاءة
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;
